module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter II")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Peter, you look every inch a king,” Calthorp said. “Hail to Peter the Sixth!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Calthorp, despite his ironic tone, meant what he said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Stagg was six-feet-six-inches tall, weighed two hundred and thirty-five pounds, and had a forty-eight-inch chest, thirty-two-inch waistline, and thirty-six-inch hips. His red-gold hair was long and wavy. His face was handsome as an eagle’s was handsome. Just now he looked like an eagle in his cage, for he was pacing back ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("and forth, hands behind his back like folded wings, his head bent forward, his dark blue eyes fierce and intent. Now and then he scowled at Calthorp.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The anthropologist was slumped in a huge gold-plated chair, a long jeweled cigar holder dangling from his lips. He, like Stagg, had permanently lost his facial hair. One day after landing, they had been showered, shampooed, and massaged. The servants had shaved them by simply applying a cream to their faces and then wiping the cream off with a towel. Both men thought this was a delightfully easy way to shave until they discovered that the cream had deprived them forever of their right to grow whiskers if they felt like it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Calthorp cherished his beard, but he had not objected to being shaved because the natives made it clear that they regarded beards as an abomination and a stench in the nostrils of the Great White Mother. Now he lamented its disappearance. He had not only lost his patriarchal appearance, he had exposed his weak chin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly, Stagg halted his pacing to stand before the mirror that covered one wail of the tremendous room. He looked hard at his image and at the crown on his head. It was gold, with fourteen points, each tipped by a large diamond. He looked at the inflated green velvet collar around his neck, and at his bare chest, on which was painted a flaming sun. He regarded distastefully the broad jaguarskin belt around his waist, the scarlet kilt, the enormous black phallic symbol stitched to the front of the kilt, the shiny, white leather, knee-length boots. He looked at the King of Deecee in all his splendor, and he snarled. He jerked off the crown and savagely threw it across the room. It struck the far wall and rolled back across the room to his feet.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“So I’ve been crowned ruler of Deecee!” he shouted. “King of the Daughters of Columbia. Or, as they say in their degenerate American, Ken-a dot uh K’lumpaha.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kind of a monarch am I? I am not allowed to exercise any of the powers and privileges a king should have. I have been ruler of this woman-ridden land for two weeks, and I’ve had all sorts of parties in my honor. I’ve had my praises sung, literally, everywhere I go with my one-breasted Guard of Honor. I am initiated into the totem frat of the Elks—and let me repeat—they were the weirdest rites I’ve ever heard of. And I was chosen Big Elk of the Year …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naturally, with a name like Stagg, you’d belong to the Elks,” Calthorp said. “It’s a good thing they didn’t find out your middle name was Leo. They’d have had a hell of a time deciding whether you belonged to the Elks or the Lions. Only …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He frowned. Stagg kept on raving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They tell me I am Father of My Country. If I am, why don’t I get a chance to be one? They won’t allow a woman to be alone with me! When I complain about it, that lovely bitch, the Chief Priestess, tells me I am not allowed to discriminate in favor of any one woman. I am the father, lover, and son, of every woman in Deecee!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Calthorp was looking gloomier and gloomier. He rose from his chair and walked to the huge French windows on the second story of the White House. The natives thought the royal mansion was named so in honor of the Great White Mother. Calthorp knew better, but he was too intelligent to argue. He motioned to Stagg to come by him and look out. Stagg did so, but he sniffed loudly and made a face.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Calthorp pointed out the window to the street. Several men were lifting a large barrel onto the back of the wagon.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honeydippers was the ancient name for them,” said Calthorp. “Every day they come by and collect their stuff for the fields. This is a world where every little grunt is for the glory of the nation and the enrichment of the soil.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’d think we’d be used to it by now,” Stagg said. “But the odor seems to get stronger every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, it’s not a new odor around Washington. Though in the old days there was less of the human and more of the bull.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stagg grinned and said, “Who ever thought America, land of the two-bathroom house, would go back to the little house with the crescent on the door? Except the little houses don’t have doors. It’s not because they don’t know anything about plumbing. We have running water in our apartments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything that comes out of the earth must go back to the earth. They don’t sin against Nature by piping millions of tons of phosphates and other chemicals, which the soil needs, into the ocean. They’re not like we were, blind stupid fools killing our earth in the name of sanitation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This lecture wasn’t why you called me to the window,” Stagg said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it was. I wanted to explain the roots of this culture. Or try to. I’m handicapped because I’ve spent most of my time learning the language.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s English. But farther from our brand than ours was from Anglo-Saxon.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("“It’s degenerated, in the linguistic sense, far faster ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("than was predicted. Probably because of the isolation of small groups after the Desolation. And also because the mass of the people are illiterate. Literacy is almost the exclusive property of the religious ministers and the diradah.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Diradah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The aristocrats. I think the word originally was deer-riders. Only the privileged are allowed to ride deer. Diradah. Analogous to the Spanish caballero or French cavalier. Both originally meant horseman. I’ve several things to show you, but let’s look at that mural again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They walked to the far end of the long room and stopped before an enormous and brightly colored mural.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This painting,” Calthorp said, “depicts the great basic myth of Deecee. As you can see—” he pointed at the figure of the Great White Mother towering over the tiny plains and mountains and even tinier people “—she is very angry. She is helping her son, the Sun, to blast the creatures of Earth. She is roiling back the blue shield she once flung around Earth to protect it from the fierce arrows of her son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Man, in his blindness, greed, and arrogance, has fouled the Goddess-given earth. His ant-heap cities have emptied their filth into the rivers and seas and turned them into vast sewers. He has poisoned the air with deadly fumes. These fumes, I suppose, were the products not only of industry but of radioactivity. But the Deecee, of course, know nothing of atomic bombs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Then Columbia, unable any longer to endure man’s poisoning of Earth and his turning away from her worship, ripped away her protective shield around ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Earth and allowed the Sun to hurl the full force of his darts upon all living creatures.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see all those people and animals falling down all over Earth,” Stagg said. “On the streets, in the fields, on the seas, in the air. The grasses shrivel, and the trees wither. Only the humans and animals lucky enough to have been sheltered from the Sun’s arrows survived.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not so lucky,” Calthorp said. “They didn’t die from sunburn, but they had to eat. The animals came forth at night and ate the carrion and each other. Man, after devouring all the canned goods, ate the animals. And then man ate man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fortunately, the deadly rays lasted only a short time, perhaps less than a week. Then the Goddess relented and replaced her protective shield.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what was the Desolation?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can only surmise. Do you remember that just before we left Earth the government had commissioned a research company to develop a system for broadcasting power over the entire planet? A shaft was to be sunk into the earth deep enough to tap the heat radiating from the core. The heat was to be converted into electricity and transmitted around the world, using the ionosphere as a medium of conduction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Theoretically, every electrical system on the planet could tap this power. That meant, for instance, that the city of Manhattan could draw down from the ionosphere all the power it needed to light and heat all buildings, run all TV sets, and, after electric motors were installed, power all vehicles.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“I believe that the idea was realized about twenty-five years after we left Earth. I also believe that the warnings of some scientists, notably Cardon, were justified.")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v(" Cardon predicted that the first full-scale broadcast would strip away a part of the ozone layer.”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“My God!” Stagg said. “If enough ozone in the atmosphere was destroyed…!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The shorter waves of the ultraviolet spectrum, no longer absorbed by the ozone, would fall upon every living creature exposed to the sunlight. Animals—including man—died of sunburn. Plants, I imagine, were sturdier. Even so, the effect on them must have been devastating enough to account for the great deserts we saw all over Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And as if that wasn’t enough, Nature—or the Goddess, if you prefer—struck man just as he was shakily getting to his feet. The ozone imbalance must have lasted a very short time. Then natural processes restored the normal amount. But about twenty-five years later, just as man was beginning to form small isolated societies here and there—the population must have dropped from ten billion to a million in a year’s time—extinct volcano ranges all over Earth began erupting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. Maybe man’s probings into the Earth caused this second cataclysm—twenty-five years delayed because Earth works slowly, but surely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Most of Japan sank. Krakatoa disappeared. Hawaii blew up. Sicily cracked in two. Manhattan sank under the sea a few meters and then rose again. The Pacific was ringed by belching volcanoes. The Mediterranean was a lesser inferno. Tidal waves roared far inland, stopping only at the feet of the mountains. The mountains shook, and those who had escaped the tidal waves were buried under avalanches.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("“Result: man reduced to the Stone Age, the atmosphere filled with the dust and carbon dioxide that ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("make for the magnificent sunsets and subtropical climate in New York, melting icecaps.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No wonder there was so little continuity between our society and that of the survivors of the Desolation,” Stagg said. “Even so, you’d think they would have rediscovered gunpowder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why? Because making black gunpowder is so simple and so obvious!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure,” Calthorp said. “So simple and so obvious it only took mankind a mere half a million years to learn that mixing charcoal, sulfur, and potassium nitrate in the proper proportions resulted in an explosive mixture. That’s all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, you take a double cataclysm like the Desolation. Almost all books perished. There was a period of over a hundred years in which the extremely few survivors were so busy scratching out a living they didn’t have time to teach their youngsters the three R’s. The result? Abysmal ignorance, an almost complete loss of history. To these people, the world was created anew in 2100 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" or I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.,")]), _vm._v(" their time. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v("—After the Desolation. Their myths say it is so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll give you an example. Cotton-raising. When we left Earth, cotton was no longer raised, because plastics had replaced fiber clothing. Did you know that the cotton plant was rediscovered only two hundred years ago? Corn and tobacco never vanished. But until three centuries ago, people wore animal skins or nothing. Mostly nothing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Calthorp led Stagg from the mural back to the open French windows. “I digress, though we’ve little else to do. Look out there, Pete. You see a Washington, or Wazhtin as ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("it’s now called, like none we knew. Washington has been leveled twice since we left, and the present city was built two hundred years ago over the site of the dead cities. An attempt was made to model it after the previous metropolis. But a different Zeitgeist possessed the builders. They built it as their beliefs and myths dictated.”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He pointed to the Capitol. In some respects, it resembled the one they remembered. But it had two domes instead of one, and on top of each dome was a red tower.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Modeled after the breasts of the Great White Mother,” Calthorp said. He pointed at the Washington Monument, now located about a hundred yards to the left of the Capitol. It was three hundred feet high, a tower of steel and concrete, painted like a barber pole with red, white, and blue stripes and topped with a round red structure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No need to tell you what that is supposed to represent. The myth is that it belonged to the Father of His Country. Washington himself is supposed be buried under it. I heard that story last night, told in all devoutness by John Barleycorn himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stagg stepped through the open French windows onto the porch outside his second-story apartment. The porch ran completely around the second story, but Calthorp walked no farther than around the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stagg, who had delayed following him, found him leaning on the porch railing. This was composed of small marble caryatids which supported broad trays on their heads. Calthorp pointed over the tops of the thick orchard in the White House yard.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“See that white building with the enormous statue of a woman on top? She is Columbia, the Great White ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Mother, watching over and protecting her people. To us she is just a figure in a heathen religion. But to her people—our descendants—she is a vivid and vital force that directs this nation toward its destiny. And does so through ruthless means. Anybody who stands in her way is crushed—one way or another.”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw the Temple when we first came into Washington,” Stagg said. “We passed it on the way to the White House. Remember how Sarvant almost died of shame when he saw the sculptured figures on the walls?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you think of them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stagg turned red, and he growled, “I thought I was hardened, but those statues! Disgusting, obscene, absolutely pornographic! And decorating a place dedicated to worship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Calthorp shook his head. “Not at all. You have been to two of their services. They were conducted with great dignity and great beauty. The state religion is a fertility cult, and those figures are representations of various myths. They tell stories whose obvious moral is that man has once almost destroyed the earth because of his terrible pride. He and his science and arrogance upset the balance of Nature. But now that it is restored, it is up to man to retain his humility, to work hand in hand with Nature—whom they believe to be a living goddess, whose daughters mate with heroes. If you noticed, the goddesses and heroes depicted on the walls emphasized through their postures the importance of the worship of Nature and fertility.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes? From some of the positions they were in, I’d say they certainly weren’t going to fertilize anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Calthorp smiled. “Columbia is also the goddess of erotic love.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“I have the feeling,” Stagg said, “that you’re trying to tell me something. But you’re taking a very indirect route. I also have a feeling that I won’t like what you’re trying to tell me.”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At that moment they heard the clanging of a gong in the room they’d just left. They hurried back to see what was going on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were greeted by a blast of trumpets and roll of drums. In marched a band of musician-priests from the nearby Georgetown University. These were fat well-fed fellows who had castrated themselves in honor of the Goddess—and, incidentally, to get a lifelong position of prestige and security. Like women, they were dressed in high-necked, long-sleeved blouses and ankle-length skirts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Behind them walked the man known as John Barleycorn. Stagg didn’t know his real name; “John Barleycorn” was evidently a title. Nor did Stagg know Barleycorn’s exact position in the government of Deecee. He lived in the White House, on the third floor, and seemed to have much to do with the administration of the country. His function was probably similar to that of the Prime Minister of ancient Great Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Sunheroes, like the monarch of that country, were more figureheads, binders of loyalty and tradition, than actual rulers. Or so it seemed to Stagg, who had been forced to guess at the meaning of most of the phenomena that flashed and buzzed within him during his imprisonment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Barleycorn was a very tall and very thin man of about thirty-five. His long hair was dyed a bright green, and he wore green spectacles. His long ski-slope nose and his face were covered with broken red veins. He wore a tall green plug hat. Around his neck hung a string of ears of corn. His torso was bare. His kilt was green, and the sporran hanging from his belt was made of stiff cloth shaped like the leaves of corn. His sandals were yellow.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("In his right hand he carried his emblem of office, a large bottle of white lightning.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hail, man and myth!” he said to Stagg. “Greetings to the Sunhero! Greetings to the romping, snorting stag of the Elk totem! Greetings to the Father of His Country and the Child and Lover of the Great White Mother!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took a long swig from the bottle, smacked his lips, and passed it to Stagg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need that,” said the captain, and swallowed a mouthful. A minute later, after choking, gasping, and weeping great tears, he returned the bottle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barleycorn was elated. “You gave a splendid performance, Noble Elk! You must have been visited by the special potency of Columbia Herself to be so stricken by the white lightning. Indeed, you are divine! Now take me, I am only a poor mortal, and when I first drank white lightning, I was affected. Still, I must confess that when I first assumed office as a lad I was able to feel the holy presence of the Goddess in the bottle and to be affected as much as yourself. But a man may become hardened even to divinity, may She pardon my saying so. Have I ever told you the story of how Columbia first liquefied a lightning bolt and then bottled it? And how She gave it to the first man, none other than Washington himself? And how disgracefully he behaved and thereby incurred the wrath of the Goddess?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have? Well, to business, then. I am preceding the Chief Priestess herself to give you a message. To whit and to-whooooo! Tomorrow is the birthday of the Son of the Great White Mother. And you, the child of Columbia, will be born tomorrow. And then what has been will be.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("He took another drink, bowed to Stagg, almost fell on his face, recovered, and staggered out of the room.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Stagg called him back. “Just a minute! I want to know what has happened to my crew!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barleycorn blinked. “I told you that they were in a building on the campus of Georgetown University.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to know where they are now—at this moment!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They are being treated very well. Anything they want they may have, except their freedom. And they will get that day after tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because you, too, will be released. Of course, you won’t be able to see them then. You’ll be on the Great Route.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It will be revealed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barleycorn turned to leave, but Stagg said, “Tell me, why is that girl being kept in a cage? You know, the one with the sign that says: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MASCOT, CAPTURED IN A RAID ON CASEYLAND")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That, too, will be revealed, Sunhero. Meanwhile, I suggest that it is unbecoming in a man of your importance to lower himself by asking questions. The Great White Mother will explain everything in due time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After Barleycorn had left, Stagg said to Calthorp, “What nonsense is he trying to cover up?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("The little man frowned. “Wish I knew. After all, my chances for an examination into the social mechanisms ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("of this culture have been rather limited. It’s just that there is …”")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s what?” Stagg said anxiously. Calthorp was looking very gloomy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tomorrow is the winter solstice. Midwinter—when the sun is weakest in the northern hemisphere and has reached its most southerly station. On the calendar we knew, it was December twenty-first or twenty-second. As near as I can remember, that was a very important date in prehistoric and even historic times. All sorts of ceremonies connected with it, such as … ahhh!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was more a wail than an exclamation of sudden remembrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stagg became even more alarmed. He was about to ask him what was wrong, but he was interrupted by another blast from the band. The musicians and the attendants faced the door and fell on their knees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They cried in unison, “Chief Priestess, living flesh of Virginia, daughter of Columbia! Holy maiden! Beautiful one! Virginia, soon to lose to the raging stag—heedless, savage, tearing male—your sanctified and tender fold! Blessed and doomed Virginia!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A tall girl of eighteen walked haughtily into the apartment. She was beautiful, though she had a high-bridged nose and a very white face. Her full lips were red as blood. Her blue eyes were piercing and unflinching as a cat’s. Her curling honey-colored hair fell to her hips. She was Virginia, graduate of Vassar College for Oracular Priestesses and incarnate daughter of Columbia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, mortals,” she said in a high clear voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked at Stagg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, immortal.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“Hello, Virginia,” he answered. He felt the blood spurting through his flesh and the ache building up in his chest and loins. Every time he met her, he experienced this almost irrepressible desire for her. He knew that if he were left alone with her, he would take her, no matter what the consequences.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Virginia gave no sign that she was aware of her effect upon him. She regarded him with the cool unfaltering stare of a lioness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Virginia, like all mascots, was clothed in a high-necked and ankle-length garment, but her garment was covered with large pearls. A large triangular opening in the dress exposed her large but upthrusting breasts. The areola of each was rouged and circled by two rings of blue and white paint.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tomorrow, immortal, you will become both Child and Lover of the Mother. Therefore, it is necessary that you prepare yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just what do I have to do to prepare myself?” Stagg said. “And why should I?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at her and ached through his whole body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She motioned with one hand. Instantly John Barleycorn, who must have been waiting around the corner, appeared. He now carried two bottles, the white lightning and some dark liquor. A priest-eunuch offered him a cup. He filled it with the dark stuff, and handed it to the priestess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only you, Father of Your Country, may drink this,” she said, giving the cup to Stagg. “This is the best. Made from the waters of the sticks.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Stagg took the cup. He looked at it dubiously, but he tried to be nonchalant. “Real mountain hooch, hey? Well, here goes. Never let anybody say that later Stagg ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("couldn’t outdrink the best of them. Aaoi-whoosh!”")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The trumpets blew, the drums beat, the attendants clapped their hands and whooped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was then that he heard Calthorp protesting. “Captain, you misunderstood! She didn’t say sticks. She said Styx. Waters of the S-T-Y-X! Get it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stagg had gotten it, but there was nothing he could do about it. The room whirled around and around, and darkness rushed in like a great black bat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Amid the trumpets and the beating, he fell headlong toward the floor.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303148f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter02.vue
// module id = 69
// module chunks = 0